module.exports = __webpack_public_path__ + "img/package.380cb5e4.svg";